import { ILocalAudioTrack, IRemoteAudioTrack } from "agora-rtc-sdk-ng";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
const speaker = require("../../assets/speaker.png");
const speaker_off = require("../../assets/speaker_off.png");
const camera = require("../../assets/camera.png");
const camera_off = require("../../assets/camera_off.png");
const hang_up = require("../../assets/hang_up.png");
interface ActionButtonProps {
  variant: "camera" | "mic" | "telephone";
  style?: React.CSSProperties;
  state?: boolean;
  onClick?: (arg: boolean) => void;
}

function ActionButton2(props: ActionButtonProps) {
  const [src, setSrc] = useState<{ on: any; off: any }>({
    on: undefined,
    off: undefined,
  });
  const [on, setOn] = useState(props.state ?? true);
  const { style, variant, onClick } = props;
  useEffect(() => {
    switch (variant) {
      case "camera":
        setSrc({ on: camera, off: camera_off });
        break;
      case "mic":
        setSrc({ on: speaker, off: speaker_off });
        break;
      case "telephone":
        setSrc({ on: hang_up, off: hang_up });
        break;
    }
  }, [props.state, variant]);
  return (
    <Button
      style={{
        backgroundColor: "transparent",
        backgroundRepeat: "no-repeat",
        border: "none",
        cursor: "pointer",
        overflow: "hidden",
        outline: "none",
        ...style,
      }}
      onClick={() => {
        setOn(!on);
        onClick && onClick(!on);
      }}
    >
      <img
        style={{ height: "100%", width: "100%" }}
        src={on ? src.on : src.off}
        alt={variant ? `${variant} button` : "No description"}
      />
    </Button>
  );
}

interface MicPros extends Omit<ActionButtonProps, "variant"> {
  delta?: number;
  getStreams?: () => {
    local: ILocalAudioTrack;
    remote: IRemoteAudioTrack | undefined;
  };
  style?: React.CSSProperties;
  onClick?: (arg: boolean) => void;
}

function MicActionButton(props: MicPros) {
  const [agent, setAgent] = useState(0);
  const [value, setValue] = useState(0);

  const [on, setOn] = useState(props.state ?? true);
  useEffect(() => {
    const interval = setInterval(() => {
      if (!props.getStreams) return;
      const { local, remote } = props.getStreams();
      if (local && local.trackMediaType === "audio") {
        console.debug("local", local.getVolumeLevel() * 200);
        setValue(local.getVolumeLevel() * 50);
      }
      if (remote) {
        console.debug("remote", remote.getVolumeLevel() * 200);
        setAgent(remote.getVolumeLevel() * 100);
      }
    }, 500);
    return () => {
      clearInterval(interval);
    };
  });
  return (
    <Button
      onClick={() => {
        setOn(!on);
        props.onClick && props.onClick(!on);
      }}
      style={{
        backgroundColor: "transparent",
        backgroundRepeat: "no-repeat",
        border: "none",
        cursor: "pointer",
        overflow: "hidden",
        outline: "none",
        ...props.style,
      }}
    >
      <img
        src={{ on: speaker, off: speaker_off }[on ? "on" : "off"]}
        alt="Speaker button"
        style={{
          borderBottomColor: `hsl(257,${20 + value}%,58%)`,
          borderRightColor: `hsl(257,${20 + value}%,58%)`,
          borderTopColor: `hsl(307,${20 + agent}%,58%)`,
          borderLeftColor: `hsl(307,${20 + agent}%,58%)`,
          borderWidth: "0.5rem",
          borderStyle: "solid",
          borderRadius: "50%",
          height: "100%",
          width: "100%",
          padding: "0",
          aspectRatio: "1/1",
        }}
      />
    </Button>
  );
}
function AnimatedGif(props: MicPros) {
  const [agent, setAgent] = useState(0);

  const [on, setOn] = useState(props.state ?? true);
  useEffect(() => {
    const interval = setInterval(() => {
      if (!props.getStreams) return;
      const { local, remote } = props.getStreams();
      if (local && local.trackMediaType === "audio") {
        console.debug("local", local.getVolumeLevel() * 200);
      }
      if (remote) {
        console.debug("remote", remote.getVolumeLevel() * 200);
        setAgent(remote.getVolumeLevel() * 100);
        setOn(agent * 0.25 + remote.getVolumeLevel() * 75 > 50);
      }
    }, 500);
    return () => {
      clearInterval(interval);
    };
  });
  return (
    <Button
      onClick={() => {
        setOn(!on);
        // props.onClick && props.onClick(!on);
      }}
      style={{
        backgroundColor: "transparent",
        backgroundRepeat: "no-repeat",
        border: "none",
        cursor: "pointer",
        overflow: "hidden",
        outline: "none",
        ...props.style,
      }}
    >
      <img
        src={
          {
            on: require("../../assets/talking.gif"),
            off: require("../../assets/Idle_fit.png"),
          }[on ? "on" : "off"]
        }
        alt="Speaker button"
        style={{
          height: "100%",
          width: "100%",
          padding: "0",
          aspectRatio: "1/1",
        }}
      />
    </Button>
  );
}
export { MicActionButton, AnimatedGif };
export default ActionButton2;
